import React from "react";
import "./style.scss";
import Icon from "../icons";


const Confirm = (props) => {
    return(
        <div className="thanks-block">
                <div className="p-10">
                    <p className="mb-10">Do you want to remove the card?</p>
                </div>
            <div className="thanks-b tn-block p-10">
                    <button disabled={props.loading} onClick={props.onOk} className={`btn btn-primary mr-10 ${props.loading?"disabled":""}`}>REMOVE
                    {props.loading ? <i className="icon-spinner top-4 ml-5 btn-loader"><Icon name="spinner" /> </i>  : null }                  
                    </button>
                    <button disabled={props.loading} onClick={props.onCancel} className="btn btn-border">NO
                    </button>
            </div> 
        </div>
    )
};

export default Confirm;